import { render, staticRenderFns } from "./SellCard.vue?vue&type=template&id=79d1672e&scoped=true&"
import script from "./SellCard.vue?vue&type=script&lang=js&"
export * from "./SellCard.vue?vue&type=script&lang=js&"
import style0 from "./SellCard.vue?vue&type=style&index=0&id=79d1672e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d1672e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/shashwat/CampusBox/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCarousel,VCarouselItem,VDivider,VIcon,VLayout,VSpacer,VTab,VTabItem,VTabs})
